import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Text,
  Input,
  Row,
  Checkbox,
  useInput,
} from "@nextui-org/react";
import { Mail } from "./Mail";
import { Password } from "./Password";
import loginImg from "../../asset/login.png";
import useStorage from "../storage/useLocalStorage";
import { makeFetch } from "../../service/makeFetch";
import { useNotifications } from "reapop";

export default function Login() {
  const [_ = false, setDoingAction] = useStorage("doingAction");
  const [userAuthenticated = false, setUserAuthenticated] =
    useStorage("userAuthenticated");
  const [userId = "", setUserId] = useStorage("userId");
  const [authorizationToken = "", setAuthorizationToken] =
    useStorage("authorizationToken");
  const [developerKey = "", setDeveloperKey] = useStorage("developerKey");
  const [userEmail = "", setUserEmail] = useStorage("userEmail");
  const [refreshAccount = false, setRefreshAccount] =
    useStorage("refreshAccount");
  const [userRole = "user", setUserRole] = useStorage("userRole", "user");
  const [v_api = "v1", setV_api] = useStorage("v_api", "v1");

  const [visible, setVisible] = React.useState(true);
  const { notify } = useNotifications();
  const emailValue = useInput("");
  const passwordValue = useInput("");
  const adminKeyValue = useInput("");
  const [toCreateAccount, setToCreateAccount] = useState(false);

  useEffect(() => {
    checkUser({
      developerPlayGroundKey: developerKey,
      email: userEmail,
    });
  }, []);

  useEffect(() => {
    if (refreshAccount === true) {
      checkUser({
        developerPlayGroundKey: developerKey,
        email: userEmail,
      });
    }
  }, [refreshAccount]);

  const validateEmail = (value) => {
    if (value === null || value === undefined || value === "") return false;
    return value.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}$/i);
  };

  const helper = React.useMemo(() => {
    if (!emailValue.value)
      return {
        text: "",
        color: "",
      };
    const isValid = validateEmail(emailValue.value);
    return {
      text: isValid ? "Correct email" : "Enter a valid email",
      color: isValid ? "success" : "error",
    };
  }, [emailValue.value]);

  const closeHandler = () => {
    setVisible(false);
  };

  const toSubmit = () => {
    const isValid = validateEmail(emailValue.value);
    if (isValid === false)
      return notify("Please provide proper email!", "error");
    // if (
    //   toCreateAccount !== true &&
    //   (passwordValue.value === "" ||
    //     passwordValue.value === null ||
    //     passwordValue.value === undefined)
    // )
    //   return notify("Please provide proper password!", "error");
    checkUser({
      developerPlayGroundKey: adminKeyValue.value,
      handle: emailValue.value,
      email: emailValue.value,
    });
  };

  const checkUser = async ({ developerPlayGroundKey, handle, email }) => {
    setDoingAction(true);
    var obj = {
      idType: "developer",
      developerPlayGroundKey,
      handle,
      email,
      authActionCreateAccountKey: "r7TzL1qA9sG3pW6_creation_account_2024", // TO DO: this should be hidden
      createAccountWhenNotFound: false,
    };
    const result = await makeFetch({
      url: "account/create",
      method: "POST",
      body: obj,
    });
    setRefreshAccount(false);
    if (result === undefined || result === null) {
      notify("Error Auth failed!", "error");
      setDoingAction(false);
      return;
    }
    if (result?.error === true) {
      notify(result.message, "error");
      setUserAuthenticated(false);
      setDoingAction(false);
      return;
    }
    if (typeof window !== "undefined") {
      window.localStorage.setItem("userName", JSON.stringify(result.handle));
      setUserId(result.userId);
      setDeveloperKey(result.developerKey);
      setUserRole(result.role);
      setUserEmail(result.email);
      setAuthorizationToken(result.authorizedToken);
      setV_api(result.v_api);
      setUserAuthenticated(true);
    }
    notify(
      refreshAccount === true
        ? "Account refreshed!"
        : `Welcome ${result.existing === 1 ? "back" : "onboard"}!`,
      "success"
    );
    closeHandler();
    setDoingAction(false);
  };

  const changeAuthType = () => {
    setToCreateAccount((e) => !e);
  };
  return (
    <div>
      <Modal
        // closeButton
        preventClose
        aria-labelledby="modal-title"
        open={userAuthenticated !== true}
        onClose={closeHandler}
        blur
      >
        <Modal.Header style={{ flexDirection: "column" }}>
          <Text id="modal-title" size={18}>
            Welcome to
            <Text b size={18}>
              {" "}
              Youniverse.game
            </Text>
          </Text>
          <div className="loginImage">
            <img
              src={loginImg}
              width="300"
              style={{ position: "relative" }}
              alt="login"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <Input
            {...emailValue.bindings}
            onClearClick={emailValue.reset}
            clearable
            bordered
            fullWidth
            size="lg"
            placeholder="Email"
            contentLeft={<Mail fill="currentColor" />}
            status={helper.color}
            color={helper.color}
            helperColor={helper.color}
            helperText={helper.text}
          />
          {/* {toCreateAccount !== true && (
            <Input
              {...passwordValue.bindings}
              clearable
              bordered
              fullWidth
              color="primary"
              size="lg"
              placeholder="Password"
              contentLeft={<Password fill="currentColor" />}
              onClearClick={passwordValue.reset}
            />
          )} */}
          <Input
            {...adminKeyValue.bindings}
            clearable
            bordered
            fullWidth
            color="primary"
            size="lg"
            placeholder="Developer Key"
            contentLeft={<Password fill="currentColor" />}
            onClearClick={adminKeyValue.reset}
          />
          {/* {toCreateAccount !== true && (
            <Row justify="space-between">
              <Checkbox>
                <Text size={14}>Remember me</Text>
              </Checkbox>
              <Text size={14}>Forgot password?</Text>
            </Row>
          )} */}
          {/* <Text
            size={14}
            style={{ cursor: "pointer" }}
            // onClick={changeAuthType}
          >
            {toCreateAccount === true ? "Sing In ?" : "Create Account ?"}
          </Text> */}
        </Modal.Body>
        <Modal.Footer>
          {/* <Button auto flat color="error" onPress={closeHandler}>
            Close
          </Button> */}
          <Button auto onPress={(e) => toSubmit()}>
            Sign {toCreateAccount === true ? "up" : "in"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
